import {StyleSheet, Dimensions} from 'react-native';
import {styles} from '../../theme';
import { font } from '../../theme/Font';
const windowWidth = Dimensions.get('window').width;

export default StyleSheet.create({
  body: {
    width: windowWidth,
    position: 'absolute',
    top: 5,
    zIndex: 99999999999999,
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: '#fff',
    borderRadius : 18 , 
    borderWidth : 1 ,
    opacity: 1,
    borderRadius: 12,
    marginTop : 16 , 
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row-reverse',
    paddingVertical: 12,
    paddingHorizontal: 12,
    width: windowWidth -32 , 
  },
  screen: {
    flex: 1,
    alignSelf: 'stretch',
    alignItems: 'center',
  },
  text: {
    color: 'black',
    fontSize: 14,
    // marginHorizontal: 12,
    textAlign: 'right',
    fontFamily: font['400'],
  },
  textContainer : {
    width : windowWidth -92 , 
    marginRight : 8 , 
  }
});
